import React, { useEffect, useState } from "react";
import CloseIcon from "../../../../../../../src/assets/images/icons/close_icon.svg";
import { withTranslation } from "react-i18next";
import {
  makeAjax,
  respStatus,
  showMessage,
  url,
} from "../../../../../../helpers/global_helper";
import { formatPrice } from "../../../../../NumberFormat";

const TurnoverDatePopup = (props) => {
  const { onClose, turnoverDateId } = props;
  const [turnoverinfodatedata, setTurnoverInfoDateData] = useState([]);

  // api for Turnover Bonus Date popup
  const fetchTurnoverInfoDateData = () => {
    let reqData = {
      date: turnoverDateId,
    };
    makeAjax(url.PLAYER_API.getTurnover, reqData, url.PLAYER_MS_EXT).then((response) => {
      if (response.status != respStatus["SUCCESS"]) {
        if (response.code != "validation_error") {
          showMessage("server connection lost", "error", "not getting data");
          return;
        }
        showMessage("server connection lost ", "error", "not geeting data");
        return;
      }
      setTurnoverInfoDateData(response.data);
    });
  };

  useEffect(() => {
    if (turnoverDateId) {
      fetchTurnoverInfoDateData();
    }
  }, [turnoverDateId]);

  return (
    <>
      <div className="info_popup_overlay"></div>
      <div className="info_popup">
        <div className="info_popup_header ">
          <button className="info_popup_close" onClick={onClose}>
            <img src={CloseIcon} alt="" />
          </button>
          <h2>{props.t("info_turnover")} <span> {props.t("win")} / {props.t("lose")}</span></h2>
          <div className="header_bottom_border"></div>
        </div>
        <div className="info_popup_body">
          <div className="info_popup_content">
            <table className="table_data data_table1">
              <thead>
                <tr>
                  <th>{props.t("game")}</th>
                  <th>{props.t("win")} / {props.t("lose")}</th>
                  <th>{props.t("turnover")}</th>
                </tr>
              </thead>
              <tbody>
                {turnoverinfodatedata === 0 ? (
                  <tr className="table_data_empty_row">
                    <td colSpan="3">{props.t("data_not_found")}</td>
                  </tr>
                ) : (
                  turnoverinfodatedata.map((data, index) => (
                    <tr key={index} className={index % 2 === 0 ? "first_bg" : "second_bg"}>
                      <td>{data.gamename}</td>
                      <td>{formatPrice(data.winlose)}</td>
                      <td>{formatPrice(data.tover)}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default withTranslation()(TurnoverDatePopup);
